/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { LoanAgreementPO } from '@/api/contract/types';
import { session } from '@/shared/utils/storage';
import { Vue, Component } from 'vue-property-decorator';

const style = require('./index.module.scss');

@Component({ name: 'YHApplyConstract' })
export default class YHApplyConstract extends Vue {
  private loanContractForm: LoanAgreementPO = Object.create(null);

  private get funderCode() {
    return [
      'MANGGUOXIAODAI',
    ].indexOf(this.loanContractForm && this.loanContractForm.funderCode) >= 0;
  }

  private created() {
    this.loanContractForm = session.get('loanContractForm') as LoanAgreementPO;
  }

  private render() {
    const {
      userName,
      idCard,
      mobile,
      liveAddress,
      applyAmountChinese,
      effectiveDate,
      deadLine,
    } = this.loanContractForm;
    return (
      <div class={style.ApplyConstract}>
      <div class={style.content}>
      <p><strong>特别提醒：请您仔细阅读合同条款，尤其是粗体字标注部分的条款内容，包括但不限于有关争议解决方式等条款，并听取甲方或贷款平台的说明，如对甲方或贷款平台的说明不明白或有异议的，请在签署本合同之前向甲方或贷款平台进行询问，如未询问，视同已经对本合同条款内容完全理解并无异议。一旦您勾选并点击确认同意本合同，即意味着您已阅读本合同所有条款并对本合同条款的法律含义即各方权利和义务有准确无误的理解，同意以数据电文形式订立本合同并接受本合同约束。您已知晓任何欺诈、违约行为将要承担的相应法律后果。您将本着诚实信用的原则，善意签署并依约履行本合同。</strong></p>
      <p class={style.title}><strong>委托担保合同</strong></p>
      <div style="text-align:right">合同编号：</div>
      <p><strong>甲方：深圳市中裔信息工程融资担保有限公司</strong></p>
      <p><strong>乙方：{userName}</strong></p>
      <p><strong>身份证号码：{idCard}</strong></p>
      <p><strong>联系电话：{mobile}</strong></p>
      <p><strong>电子邮箱：-</strong></p>
      <p><strong>联系地址：{liveAddress}</strong></p>
      <p class={style.paragraph}>甲方根据乙方的申请及所附文件资料，同意为乙方（“借款人”）向【湖南快乐通宝科技小额贷款有限公司】（以下简称“贷款人”）申请的借款提供担保，具体担保方式及担保内容以甲方与贷款人确认的为准。甲、乙双方依照《中华人民共和国民法典》和其他相关法律、法规和规章的规定，经协商一致，以数据电文形式订立本合同，以兹共同遵照执行。</p>
      <p class={style.paragraph}><strong>第一条  担保的范围、保证期间</strong></p>
      <p class={style.paragraph}>1、根据乙方与贷款人签订的《借款合同》（以实际签订的协议名称为准，以下简称“主合同”）的有关约定，乙方向贷款人借取的借款本金为人民币【{applyAmountChinese}】元，借款期限为从{effectiveDate}起至{deadLine}止（具体起止日期以主合同为准）。</p>
      <p class={style.paragraph}>甲方担保范围包括主合同项下乙方的全部债务，包括借款本金、利息、逾期利息、罚息、违约金、损害赔偿金及贷款人实现债权、担保权利而支出的所有费用（包括但不限于诉讼费、仲裁费、评估费、律师费等）。</p>
      <p class={style.paragraph}>2、若甲方与贷款人确认的担保方式为<strong>连带责任保证担保</strong>的，则甲方的保证期间为主合同约定的债务人（即乙方）<strong>履行债务期限届满之日起两年</strong>。 如债务分期履行的，则保证期间为自本合同生效之日起至<strong>最后一期债务履行期届满之日起两年。</strong></p>
      <p class={style.paragraph}><strong>第二条  担保方式</strong></p>
      <p class={style.paragraph}>1、甲方在其担保范围内承担担保责任。如乙方在主合同约定的债务履行期届满时不履行债务的，贷款人可以要求乙方履行债务，也可以直接要求甲方在本合同约定的担保范围、保证期间内代为清偿该债务。</p>
      <p class={style.paragraph}>2、对于超出甲方的担保范围、保证期间的任何款项，甲方不承担任何担保责任。</p>
      <p class={style.paragraph}>3、甲方的担保责任随乙方履行主合同约定的还款义务或甲方代为偿还该债务或贷款人因乙方违约提前收回贷款等情况的发生而相应减少或免除。</p>
      <p class={style.paragraph}>4、本协议项下担保方式、担保范围、担保责任等与甲方与贷款人约定的不一致的，以甲方与贷款人约定的为准。</p>
      <p class={style.paragraph}><strong>第三条  甲方的抗辩权</strong></p>
      <p class={style.paragraph}>甲方依法享有担保人的抗辩权，担保人的抗辩权具有独立性，即使乙方放弃抗辩权，甲方仍有权进行抗辩。</p>
      <p class={style.paragraph}><strong>第四条  甲方的追偿权</strong></p>
      <p class={style.paragraph}>1、甲方在按照本合同第二条的约定履行了担保责任，代乙方向贷款人清偿债务后，甲方有权要求乙方继续按照本合同之约定支付担保费用，直至乙方依约履行完毕主合同和本合同项下全部应付款义务。</p>
      <p class={style.paragraph}>2、甲方在按照本合同第二条的约定履行了担保责任，代乙方向贷款人清偿债务后，甲方有权要求乙方按照主合同约定履行逾期状态下的还款义务以及由此给甲方造成的一切损失和其他费用支出（包括但不限于调查费、诉讼费、仲裁费、公证费、财产保全费、律师费、差旅费、执行费、评估费、拍卖费等款项）。</p>
      <p class={style.paragraph}>3、甲方在履行本合同项下担保责任而代为向贷款人垫付任何款项后，甲方有权自行向乙方追偿，或者授权贷款人、第三方向乙方追偿。</p>
      <p class={style.paragraph}><strong>第五条  甲方的其他权利</strong></p>
      <p class={style.paragraph}>本合同生效后，乙方发生下列情况之一时，甲方有权撤销为乙方向贷款人所提供的担保，并有权要求乙方提前归还主合同项下的借款，并且乙方应赔偿甲方因此所受到的一切损失：</p>
      <p class={style.paragraph}>1、乙方向甲方隐瞒与订立本合同有关的重要事实或者提供虚假的证明、材料；</p>
      <p class={style.paragraph}>2、乙方与其他第三方签订有损甲方权益的合同；</p>
      <p class={style.paragraph}>3、乙方拒绝或阻挠甲方对借款情况进行监督检查；</p>
      <p class={style.paragraph}>4、甲方有理由认为乙方有可能出现资信状况恶化、到期无力偿还贷款人借款的情况或乙方明确表示到期无力偿还债务；</p>
      <p class={style.paragraph}>5、甲方认为乙方发生其它损害或可能损害甲方权益的事项。</p>
      <p class={style.paragraph}><strong>第六条  乙方的义务</strong></p>
      <p class={style.paragraph}>1、乙方应向甲方支付担保费，其中：担保费率为年化【    】（以贷款余额为计算基数，按照实际使用月份计算），随乙方每期应还款项一同划扣、支付，具体以贷款平台页面展示的还款计划为准。</p>
      <p class={style.paragraph}>2、本合同项下乙方担保费的支付方式与乙方在主合同项下借款的还款方式保持一致，即乙方按照主合同项下借款的分期偿还期数，分期向甲方支付担保费（详见贷款平台页面的还款计划表）。乙方应于还款日当天将足额担保费支付至绑定的还款账户，并授权甲方或甲方合作方合作的第三方支付机构于还款日当天扣收相应的担保费，扣收失败的，乙方应于还款日当天通过贷款平台主动支付当期担保费，贷款人未及时代甲方收到当期担保费的，视为乙方逾期支付。如乙方申请提前结清主合同项下全部借款、利息及其他款项的，服务是否可用以操作界面展示为准（受银行结算等影响，部分日期可能无法发起申请）。乙方选择提前结清的，甲方有权按照剩余本金的实际持有天数计算乙方当期应付担保费（即提前结清时点后的第一个还款日约定应支付的担保费），具体以乙方发起提前结清时服务页面显示为准。各方向乙方收取的综合成本（利息、担保费、违约金等）应符合法律法规、监管要求，超出部分甲方不予收取。</p>
      <p class={style.paragraph}>3、乙方必须严格执行对甲方做出的所有承诺、约定及相关合同，如有违反，需承担违约责任并赔偿甲方因乙方违约而遭受的一切损失。</p>
      <p class={style.paragraph}>4、乙方必须按照主合同的约定用途使用借款，并按照主合同约定的还款方式、资金来源、时间、数额等执行还款计划，否则，乙方对于由此造成的甲方的一切损失应负赔偿责任。</p>
      <p class={style.paragraph}>5、乙方应在接到甲方书面通知后次日向甲方清偿本合同第四条约定的全部款项。上述书面通知对乙方有法律约束力，乙方逾期支付的，甲方有权委托相关银行或有资质的第三方从乙方账户上代为扣还上述款项，并保留追究乙方法律及经济责任的一切权利，乙方对此知晓且无条件同意。</p>
      <p class={style.paragraph}>6、下列事项发生后，乙方应及时书面通知甲方：</p>
      <p class={style.paragraph}>（1）涉及重大诉讼案件</p>
      <p class={style.paragraph}>（2）被采取了财产保全措施或强制执行措施</p>
      <p class={style.paragraph}>乙方应于应诉通知书、诉讼保全裁定书送达乙方的当日书面通知甲方，或在可能出现强制执行措施前书面通知甲方。</p>
      <p class={style.paragraph}>7、未经甲方书面同意，乙方不得擅自变更主合同（包括但不限于改变借款用途等）；不得擅自将债务转让给其他第三方或约定由第三方履行债务。</p>
      <p class={style.paragraph}>8、乙方知悉在乙方签署本合同后即授权甲方及甲方合作方以乙方的名义向甲方合作的电子签名认证机构申请乙方数字证书，该乙方数字证书由甲方合作的电子签名认证机构保存。当乙方发起签章指令、乙方授权甲方或甲方合作的第三方代为发起签章指令后，甲方合作的电子签名认证机构即在相关合同或文件上使用乙方数字证书签章。</p>
      <p class={style.paragraph}><strong>第七条 乙方信息收集及使用</strong></p>
      <p class={style.paragraph}>1、乙方需保证其向甲方提供的所有申请信息均真实、完整、准确、合法及有效，并同意甲方向中国人民银行金融信用信息基础数据库、以及其他依法设立的征信机构（包括但不限于百行征信有限公司、朴道征信有限公司等）、资信评估机构或有关法律、监管机构许可的类似机构（以下统称“征信机构”）收集乙方个人基本信息、信用信息等信息：</p>
      <p class={style.paragraph}>(1) 乙方的身份信息，包括但不限于姓名、证件类型、证件号码、身份证的复印件、扫描件或照片等、住所地址、电话号码、电子邮箱以及其他身份信息。</p>
      <p class={style.paragraph}>(2) 乙方在申请、使用甲方提供的服务时所提供以及形成的任何数据和信息。</p>
      <p class={style.paragraph}>(3) 乙方的信用信息，包括但不限于乙方的征信记录和信用报告。</p>
      <p class={style.paragraph}>(4) 乙方的财产信息，包括但不限于个人经营状况、财税信息、房产信息、车辆信息、基金、保险、股票、信托、债券、互联网金融等投资理财信息和负债信息等；乙方同意并确认，乙方在将前述信息提供给甲方之前已清楚知晓可能带来的不利后果，包括但不限于基于前述信息对乙方做出负面评价。</p>
      <p class={style.paragraph}>（5）乙方在行政机关、司法机关留存的任何信息，包括但不限于户籍信息、工商信息、诉讼信息、执行信息和违法犯罪信息等。</p>
      <p class={style.paragraph}>（6）与乙方申请或使用甲方服务相关的、乙方留存在其他自然人、法人和组织的其他相关信息。</p>
      <p class={style.paragraph}>2、基于甲方需要经过严格风险评估确定是否为乙方提供服务，乙方同意并授权甲方将其信息用于如下用途：</p>
      <p class={style.paragraph}>（1）合理评估乙方的财务状况，防控风险。</p>
      <p class={style.paragraph}>（2）比较信息的准确性并与第三方征信机构进行验证。</p>
      <p class={style.paragraph}>（3）创建数据分析模型，为乙方提供适合于乙方的服务，并维护、改进这些服务。</p>
      <p class={style.paragraph}>（4）根据催收需要，将乙方的信息提供给贷款人、催收公司、律师事务所、法院、仲裁委员会和其他有权机关。</p>
      <p class={style.paragraph}>（5）经法律法规或者乙方许可的其他用途。</p>
      <p class={style.paragraph}>3、甲方对乙方的信息承担保密义务，不会为满足第三方的营销目的而向其出售或出租乙方的任何信息，甲方会在下列任一情况下才将乙方的信息与第三方共享：</p>
      <p class={style.paragraph}>（1）向甲方提供本合同项下服务必须合作的技术服务方（包括但不限于平台运营机构）分享乙方信息。</p>
      <p class={style.paragraph}>（2）除前述情况外，第三方获得乙方的同意或授权，甲方可将其留存的信息分享至该第三方。</p>
      <p class={style.paragraph}>（3）为建立信用体系，乙方同意并授权甲方向包括但不限于中国人民银行金融信用信息基础数据库或者其他依法设立的征信机构（包括但不限于百行征信有限公司、朴道征信有限公司等）等报送乙方的个人信息和信用信息（包括不良信息）。</p>
      <p class={style.paragraph}><strong>第八条 免责条款</strong></p>
      <p class={style.paragraph}></p>
      <p class={style.paragraph}><strong></strong></p>
      <p class={style.paragraph}>1、甲方出现下列任一状况而无法正常运作，致使无法向乙方提供本合同项下服务，甲方不承担任何违约或赔偿责任，该状况包括但不限于：</p>
      <p class={style.paragraph}>（1）在甲方维护期间；</p>
      <p class={style.paragraph}>（2）电信设备出现故障不能进行数据传输的；</p>
      <p class={style.paragraph}>（3）因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成系统障碍不能执行业务的；</p>
      <p class={style.paragraph}>（4）由于黑客攻击、电信部门和其他甲方有信息技术依赖的相关部门、企事业单位技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。</p>
      <p class={style.paragraph}>2、因国家相关主管部门颁布、变更的法令、政策导致甲方不能提供本合同项下服务的，不视为甲方违约，甲方与乙方可根据相关的法令、政策变更条款内容或提前终止本合同。</p>
      <p class={style.paragraph}>3、甲方有权根据风险及自身业务运营情况需要中止（终止）向乙方提供服务，因此导致乙方无法使用服务或服务受到限制的，不视为甲方违约。</p>
      <p class={style.paragraph}><strong>第九条  合同的变更与解除</strong></p>
      <p class={style.paragraph}>在以下情况下，经贷款人同意后，可变更或解除本合同：</p>
      <p class={style.paragraph}>1、甲乙双方协商一致以书面形式确定变更或解除本合同的；</p>
      <p class={style.paragraph}>2、乙方发生本合同第五条约定的情形时，甲方有权变更或解除本合同；</p>
      <p class={style.paragraph}>3、乙方未履行本合同第六条约定的情形时，甲方有权变更或解除本合同；</p>
      <p class={style.paragraph}>4、发生下列情形之一的，本合同自动解除：</p>
      <p class={style.paragraph}>（1）非因可归责于甲方的事由而不能与贷款人订立保证合同；</p>
      <p class={style.paragraph}>（2）在甲方同意的期限内，乙方不能与贷款人订立贷款合同。</p>
      <p class={style.paragraph}>5、甲方有权因国家法律法规变化及网站运营需要不定期地拟定、修改或终止本合同，并及时以公告的方式通知乙方。经修订的条款一经通知，立即自动生效，乙方应及时关注不时发布的各项服务规则及本合同的变更。若不同意相关规则及条款修改的，应及时终止与甲方的合同。如乙方继续使用甲方提供的服务的，即视为同意更新后的合同。</p>
      <p class={style.paragraph}>6、其他法律规定或双方共同书面约定的情况。</p>
      <p class={style.paragraph}>根据上述第1款的约定变更和解除本合同的，自双方的书面条款经贷款人确认之日起生效；根据上述第2款和第3款的约定解除本合同的，自贷款人书面同意且甲方单方面解除本合同的书面通知到达乙方之日起生效；根据上述第4款的约定解除本合同的，自贷款人书面同意且该款约定的情形发生之日起生效。</p>
      <p class={style.paragraph}><strong>第十条  违约责任</strong></p>
      <p class={style.paragraph}>1、乙方的借款用途须符合本合同和主合同的约定，不得挪作他用，否则甲方有权要求乙方提前清偿甲方担保的主债权，或者由乙方向甲方提供甲方认可的担保。</p>
      <p class={style.paragraph}>2、除本第九条另外约定外，乙方未履行或未履行本合同约定的义务，造成甲方造成损失的，乙方应赔偿因此给甲方造成的一切损失（包括但不限于调查费、诉讼费、仲裁费、公证费、财产保全费、律师费、差旅费、执行费、评估费、拍卖费等款项）。</p>
      <p class={style.paragraph}><strong>第十一条  义务和责任的连续性</strong></p>
      <p class={style.paragraph}>本合同项下双方义务与责任不因任何一方的上级单位的任何指令或其地位、财力状况改变或任何一方与其他单位签订任何协议、合同、文件的无效等情形而免除；不因任何一方发生合并、分立或变更法定代表人、承办人等情形而免除。本合同双方当事人如发生合并、分立或变更等情形时，根据相关法律的规定由变更后的当事人承担或分别承担本合同项下的义务和责任。</p>
      <p class={style.paragraph}><strong>第十二条  通知和送达</strong></p>
      <p class={style.paragraph}>1、本合同履行过程中，甲方给乙方的书面通知，按照乙方在甲方合作的贷款平台和\或贷款人系统中填写的通讯地址和\或乙方的户籍地址交邮后的第三个自然日即视为送达。书面通知的形式还包括（但不限于）甲方通过在甲方合作的贷款平台以网站公告、站内短信、手机短信、电子邮件等电子方式。在采用电子方式进行送达的情况下，发送当日即视为送达。</p>
      <p class={style.paragraph}>2、乙方同意司法机关按照本合同如下的约定向乙方送达法律文书。</p>
      <p class={style.paragraph}>（1）乙对于因合同争议引起的任何纠纷，乙方声明司法机关（包括但不限于人民法院/仲裁委）可以手机短信、电子邮件等现代通讯方式或者邮寄方式向乙方送达法律文书（包括但不限于诉讼文书等法律文书）。</p>
      <p class={style.paragraph}>（2）乙方指定接受法律文书的手机号码或者电子邮箱为乙方在【湖南快乐通宝科技小额贷款有限公司】或其合作方运营管理的APP、APP平台（统称“贷款平台”）的注册账号绑定的手机号码或者电子邮箱，司法机关向该等手机号码、电子邮箱发出法律文书即视为送达。</p>
      <p class={style.paragraph}>（3）乙方指定邮寄地址为乙方的户籍地址或乙方在平台留存的乙方通讯地址、收货地址和住址。</p>
      <p class={style.paragraph}>（4）乙方同意司法机关可采取以上一种或多种送达方式向其送达法律文书，送达时间以上述送达方式中最先送达的为准。</p>
      <p class={style.paragraph}>（5）乙方承诺如送达地址有变化，乙方将及时告知保证人和\或平台变更后的送达地址。</p>
      <p class={style.paragraph}>（6）乙方已阅读并理解本条款，并保证送达地址的准确性和有效性。如因乙方提供的送达地址不准确，或者未能及时通知保证人和\或平台变更后的地址和联系方式，致使法律文书无法送达或未及时送达，乙方自行承担由此可能产生的法律后果。</p>
      <p class={style.paragraph}><strong>第十三条  争议的解决</strong></p>
      <p class={style.paragraph}>本合同发生争议或纠纷时双方当事人可以通过协商解决，协商不成的，任何一方均可向合同签订地、乙方所在地、原告所在地、债权人所在地（债权转让的，为债权受让人所在地）有管辖权的人民法院提起诉讼。</p>
      <p class={style.paragraph}><strong>第十四条  合同生效</strong></p>
      <p class={style.paragraph}>本合同经双方签字或盖章（电子签章）后生效，甲乙双方采用电子签章、电子签名签署的具备同等的法律效力。除另有约定外，非经甲方与乙方协商一致不得单方解除本合同。本合同生效后，任何有关本合同的补充、修改、变更等均须由双方协商一致并订立书面合同。</p>
      <p class={style.paragraph}><strong>第十五条 合同独立性</strong></p>
      <p class={style.paragraph}>本合同的效力独立于主合同和甲方与贷款人签署的保证合同（如适用，具体以甲方和贷款人签订的合同名称为准），主合同和保证合同的无效并不影响本合同的效力。</p>
      <p class={style.paragraph}><strong>第十六条  声明</strong></p>
      <p class={style.paragraph}><strong>甲方已提请乙方对本合同各项条款作全面、准确的理解，并应乙方的要求作了相应的条款说明。签约各方对本合同含义认识一致。</strong></p>
      <div style="text-align=left">（以下无正文，为《委托担保合同》签署页）</div>
      <p class={style.paragraph}><strong>甲方: 深圳市中裔信息工程融资担保有限公司</strong></p>
      <p class={style.paragraph}>{effectiveDate}</p>
      <p class={style.paragraph}><strong>乙方: {userName}</strong></p>
      <p class={style.paragraph}>{effectiveDate}</p>
      </div>
      </div>
    );
  }
}
